import { css } from '@emotion/css';
import React from 'react';
import { getIslandRuby } from '../../i18n';
import { replaceAllSpaces } from '../../lib/utils';

interface IslandNameProps {
  landName: string;
  landDisplayId: number;
  language: string;
}

export const IslandName: React.FC<IslandNameProps> = ({ landName, landDisplayId, language }) => {
  const { suffix, ruby } = getIslandRuby(language, landDisplayId);
  return (
    <>
      {replaceAllSpaces(landName)}
      <ruby
        className={css`
          rt {
            font-size: 0.38em;
          }
        `}
      >
        {suffix}
        <rp>(</rp>
        <rt>{ruby}</rt>
        <rp>)</rp>
      </ruby>
    </>
  );
};
